import {useEffect,useState} from "react";
import {apiRequest} from "../../shared/api/client";
export function useProductImages(codes: string[]) {
  const [available, setAvailable] = useState<Set<string>>(new Set());
  const key = [...new Set(codes)].sort().join(",");
  useEffect(() => {
    let current = true;
    if (!key) { setAvailable(new Set()); return; }
    const values = key.split(",");
    void (async () => {
      const found: string[] = [];
      for (let index=0; index<values.length; index+=100) {
        try {
          const result = await apiRequest<{ codes: string[] }>(`/api/production/reports/product-images?${new URLSearchParams({codes: values.slice(index,index+100).join(",")})}`);
          if (!current) return;
          found.push(...result.codes);
        } catch { /* Optional imagery never blocks the report. */ }
      }
      if (current) setAvailable(new Set(found));
    })();
    return () => { current = false; };
  },[key]);
  return available;
}
